export const THEMATICS = {
  BANK: 'FILTERS_THEMATICS_BANK',
  LETTER_PACKAGE: 'FILTERS_THEMATICS_LETTER',
  DT: 'FILTERS_THEMATICS_TERRITORIAL',
  INFORMATIONS_FINANCIERES: 'FILTERS_THEMATICS_INFORMATIONS_FINANCIERES',
  INNOVATION: 'FILTERS_THEMATICS_INNOVATION',
  CULTURE: 'FILTERS_THEMATICS_CULTURE',
  LOGISTIC: 'FILTERS_THEMATICS_LOGISTIC',
  MEDIA: 'FILTERS_THEMATICS_MEDIA',
  PARTNERSHIP: 'FILTERS_THEMATICS_PARTNERSHIP',
  HUMAN_RESOURCES: 'FILTERS_THEMATICS_HUMAN_RESOURCES',
  NOUVEAUX_SERVICES: 'FILTERS_THEMATICS_NOUVEAUX_SERVICES',
  GROUPE: 'FILTERS_THEMATICS_GROUPE',
  NUMERIQUE: 'FILTERS_THEMATICS_NUMERIQUE',
  ECOLOGY: 'FILTERS_THEMATICS_ECOLOGY',
  PHILATELY: 'FILTERS_THEMATICS_PHILATELY',
};
